//TAB NAMES
export const OUTSIDE_SURVEY_ADDRESS_INFO = "addressInfo";
export const OUTSIDE_SURVEY_PHOTOS = "photos";
export const OUTSIDE_SURVEY_OUTSIDE_UNITS = "outsideUnits";
export const OUTSIDE_SURVEY_OUTSIDE_INFO = "outsideInfo";
export const OUTSIDE_SURVEY_CONTACTS = "contacts";
export const OUTSIDE_SURVEY_VALIDATE = "validate";
export const OUTSIDE_SURVEY_VAL_REMARKS = "valRemarks";
//SUBTITLE NAMES
export const SUBTITLE_OUTSIDE_PHOTOS_FACADE_PHOTO =
  "outsidePhotoFacadePhotoSubTitle";
//FIELD NAMES
export const FIELD_OUTSIDE_PHOTOS_FACADE_PHOTO = "outsidePhotoFacadePhotoField";
export const FIELD_OUTSIDE_UNITS_FLOORS = "outsideUnitsFloorsField";

export enum OutsideUnitsEnum {
  FLOORS_FIELD = "outsideUnitsFloorsField",
  BUILDING_CHARACTERISTIC_FIELD = "outsideUnitsBuildingTypeField",
  ADDRESS_CHARACTERISTIC_FIELD = "outsideUnitsAddressTypeField",
  UNITS_FIELD = "outsideUnitsUnitsField",
  NUMBER_OF_ROOMS_FIELD = "outsideUnitsNumberOfRoomsField",
}

export enum OutsideInfoEnum {
  MAIN_DISTRIBUTION_SUBTITLE = "outsideInfoMainDistributionSubtitle",
  FACADE_SUBTITLE = "outsideInfoFacadeSubtitle",
  TYPE_FIELD = "mainDistribution",
  UNDERGROUND_REASON_FIELD = "mainDistributionUndergroundReason",
  FACADE_HEIGHT_FIELD = "mainDistributionHeight",
  FRONT_YARD_FIELD = "frontYard",
  FRONT_YARD_LENGTH_FIELD = "mainDistributionFrontYardLength",
  PAVEMENT_TYPE_FIELD = "mainDistributionFrontYardPavement",
  SOLUTION_DOUBT_FIELD = "solutionDoubtRemark",
  STREET_SUBTITLE = "outsideInfoStreetSubtitle",
  FACADE_OBSTACLES_FIELD = "otherObstructionTypes",
  STREET_FURNITURE_FIELD = "streetFurnitureTypes",
  STREET_PAVEMENT_FIELD = "streetPavingType",
  FRONT_YARD_PICTURES_SUBTITLE = "outsideInfoFrontYardPicturesSubtitle",
  FRONT_YARD_PICTURES_FIELD = "outsideInfoFrontYardPicturesField",
  CHARACTER_FACADE_FIELD = "patrimony",
  ELECTRICAL_CABLE_FIELD = "electricityCables",
  COAX_CABLE_FIELD = "coaxCables",
  MULTITAB_FIELD = "multiTap",
  PUBLIC_LIGHTING = "publicLightning",
  FACADE_DOUBTS_FIELD = "solutionDoubt",
  STREET_FURNITURE_QUESTION_FIELD = "streetFurniture",
  FACADE_OBSTACLES_QUESTION_FIELD = "otherObstruction",
}
